import React from "react";
import InfoTile from "../InfoTile";

function InstagramSpotlightTabComponent({ data }) {

  return (
    <div className="lyt-instafeed">
      <ul className="lyt-instafeed__wrap">
        {data.length > 0 &&
          data?.map((item, index) => {
            return (
              <li className="lyt-instafeed__item" key={index}>
                <InfoTile
                  title={item.heading}
                  mediaUrl={item?.thumbnailUrl}
                  description={item.description}
                  articleUrl={item.articleUrl}
                />
              </li>
            );
          })}
      </ul>
    </div>
  );
}

export default InstagramSpotlightTabComponent;
